(() => {
  'use strict';

  const SELECTORS = {
    toggle: '[data-toggle-modal]',
    modal: '[data-ingredients-details-modal-enabled]',
    contentBtn: '[data-toggle-modal-content]',
    summarySpan: '.ingredients-details-modal__summary span',
    details: '.ingredients-details-modal__details',
    backdrop: 'bundle-builder-ingredients-details-modal',
    modalContent: '.ingredients-details-modal',
    ctaLink: '.ingredients-details-modal__cta-link',
  };

  const ATTR = {
    open: 'data-modal-open',
    currentHandle: 'data-current-product-handle',
    contentHandle: 'data-toggle-modal-content',
    productTitle: 'data-product-title',
  };

  const setModalOpen = (modalEl, isOpen) => {
    if (!modalEl) return;
    closeDetails(modalEl);
    modalEl.setAttribute(ATTR.open, isOpen ? 'true' : 'false');
  };

  const toggleModalOpen = (modalEl) => {
    if (!modalEl) return;
    const isOpen = modalEl.getAttribute(ATTR.open) === 'true';
    setModalOpen(modalEl, !isOpen);
  };

  const setCurrentHandle = (modalEl, handle) => {
    if (!modalEl || !handle) return;
    modalEl.setAttribute(ATTR.currentHandle, handle);
  };

  const setSummaryTitle = (modalEl, title) => {
    if (!modalEl || !title) return;
    const summarySpan = modalEl.querySelector(SELECTORS.summarySpan);
    if (!summarySpan) return;
    summarySpan.textContent = title;
  };

  const closeDetails = (modalEl) => {
    if (!modalEl) return;
    const details = modalEl.querySelector(SELECTORS.details);
    if (!details) return;
    details.removeAttribute('open');
  };

  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const backdropEl = target.closest(SELECTORS.backdrop);
    if (backdropEl) {
      const modalEl = backdropEl.closest(SELECTORS.modal);
      if (modalEl && modalEl.getAttribute(ATTR.open) === 'true') {
        const clickedInsideContent = !!target.closest(SELECTORS.modalContent);
        if (!clickedInsideContent) {
          setModalOpen(modalEl, false);
          return;
        }
      }
    }

    const ctaLink = target.closest(SELECTORS.ctaLink);
    if (ctaLink) {
      const href = ctaLink.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        const modalEl = ctaLink.closest(SELECTORS.modal);
        if (modalEl) setModalOpen(modalEl, false);

        e.preventDefault();

        const id = href.slice(1);
        const el = id ? document.getElementById(id) : null;

        requestAnimationFrame(() => {
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', href);
          } else {
            location.hash = href;
          }
        });

        return;
      }
    }

    const toggleEl = target.closest(SELECTORS.toggle);
    if (toggleEl) {
      const modalEl = toggleEl.closest(SELECTORS.modal);
      if (!modalEl) return;

      toggleModalOpen(modalEl);

      if (toggleEl.hasAttribute(ATTR.contentHandle)) {
        setCurrentHandle(modalEl, toggleEl.getAttribute(ATTR.contentHandle));
        const title = toggleEl.getAttribute(ATTR.productTitle);
        if (title) setSummaryTitle(modalEl, title);
      }

      return;
    }

    const contentBtn = target.closest(SELECTORS.contentBtn);
    if (!contentBtn) return;

    const modalEl = contentBtn.closest(SELECTORS.modal);
    if (!modalEl) return;

    const handle = contentBtn.getAttribute(ATTR.contentHandle);
    if (!handle) return;

    setSummaryTitle(modalEl, contentBtn.getAttribute(ATTR.productTitle) || '');
    setCurrentHandle(modalEl, handle);
    setModalOpen(modalEl, true);
    closeDetails(modalEl);
  });
})();